export default {
      id: "launch-usage",
      viewBox: "0 0 85 85",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#launch",
      toString: function () {
        return this.url;
      }
    }